import React from 'react';

export default function GridItemAgentTools({item}) {
  const ceil = +(item.privCeil || 0);

  return <div className="text-white bg-agent-purple grid grid-cols-2 px-2">
    <div>
      <span className="fal fa-user-secret"/>
      {
        (ceil && ceil > 0.01) ? <span>{ceil?.toFixed(0)}% {' '}</span> :
          <span className="text-gray-700">{' 0 '}</span>
      }
    </div>

    <div className="text-right">
      <CouponIndicator item={item}/>
    </div>
  </div>
}

function CouponIndicator({item}) {
  const ceil = +(item.pubCeil || 0);

  // Coupons not allowed; grey text
  if (!ceil || ceil < 0.1) {
    return <span className="text-gray-700" title="No coupons allowed.">
    <span className="fal fa-tag "></span> 0
  </span>
  }

  // coupons are allowed; yellow text and the ceiling percent
  return <span className="fa-yellow-200" title={`Coupons allowed up to ${ceil}%`}>
    <span className="fa fa-tag"></span> {' ' + ceil}%
  </span>
}
